import { render } from "./Home.vue?vue&type=template&id=456567c3&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=456567c3&scoped=true&lang=css"

import exportComponent from "/Users/luqingbin/Documents/project/job_project/answer_ui1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456567c3"]])

export default __exports__